// extracted by mini-css-extract-plugin
module.exports = {"oops":"Home_oops__6nWQS","overlay":"Home_overlay__184xb","content":"Home_content__dQIjn","h":"Home_h__15fQd","info":"Home_info__1Mv4H"};